import React from 'react';
import { InputNumber } from 'antd';
import type { InputNumberProps } from 'antd/lib/input-number';
import styled from 'types/theme.types';
import { css } from '@emotion/react';
import { legacyOnly, newDesignOnly } from 'constants/themes.constants';
import { getCommonInputCssFromProps } from 'components/common/input-components/common-styles';
import omit from 'lodash/omit';

export interface NumberInputProps extends InputNumberProps {
  invalid?: boolean;
}

const NumberInput: React.FC<NumberInputProps> = ({ ...props }) => <StyledNumberInput {...omit(props, ['hideError'])} />;

// Unspecced in Figma: extrapolated from Input through the shared antd block, which also drives the
// stepper chrome. The legacy `margin-top` nudges compensated for the old arrow position.
const StyledNumberInput = styled(InputNumber)<NumberInputProps>`
  ${legacyOnly(css`
    height: 28px !important;
  `)}
  ${getCommonInputCssFromProps}

  ${legacyOnly(
    theme => css`
      .ant-input-number-input {
        height: 28px !important;
        color: ${theme.primaryBlack};
      }

      &.ant-input-number-disabled {
        background-color: ${theme.primaryGray};
      }

      .ant-input-number-handler-down-inner {
        margin-top: 3px;
      }

      .ant-input-number-handler-up-inner {
        margin-top: -4px;
      }

      .ant-input-number-handler-wrap {
        background-color: ${theme.primaryGray};
      }

      .ant-input-number-handler {
        border-color: ${theme.primaryGray};
      }

      .ant-input-number-handler svg {
        fill: ${theme.primaryBlack};
      }
    `
  )}

  ${newDesignOnly(css`
    && .ant-input-number-input::placeholder {
      color: var(--component-field-text-placeholder);
    }

    &&:hover .ant-input-number-input::placeholder {
      color: var(--component-field-text-placeholder-hover);
    }

    &&.ant-input-number-focused .ant-input-number-input::placeholder {
      color: var(--component-field-text-placeholder-active);
    }
  `)}
`;

export default NumberInput;
